import { useDispatch, useSelector } from 'react-redux';
import ContainerEdit from '@plone/volto/components/manage/Blocks/Container/Edit';
import { setUIState } from '@plone/volto/actions/form/form';
import { FeaturePanelFrame, LegacyText } from './FeaturePanelView';
import type { FeaturePanelData } from './FeaturePanelView';

type FeaturePanelEditProps = {
  data: FeaturePanelData;
  block: string;
  selected: boolean;
  [key: string]: unknown;
};

/**
 * Edit do Feature panel: a área de texto é um container de blocos
 * (ContainerEdit do core, vertical) dentro da mesma moldura da view —
 * padrão do bloco section. Campos (título, CTA, imagem, cor) na sidebar
 * via blockSchema/ContainerData do core.
 */
const FeaturePanelEdit = (props: FeaturePanelEditProps) => {
  const { data } = props;

  const selectedBlock = useSelector(
    (state: { form: { ui: { featurePanelSelected?: string | null } } }) =>
      state.form.ui.featurePanelSelected,
  );
  const dispatch = useDispatch();

  return (
    <div
      className="feature-panel-edit"
      onClick={(e: React.MouseEvent & { block?: string }) => {
        if (!e.block) dispatch(setUIState({ featurePanelSelected: null }));
      }}
      role="presentation"
    >
      <FeaturePanelFrame
        data={data}
        cta={
          data.ctaLabel && (
            // No editor o CTA não navega: o clique seleciona o bloco.
            <span className="btn feature-panel__cta">{data.ctaLabel}</span>
          )
        }
      >
        {/* Conteúdo legado (campo text) aparece como referência até ser
            substituído por blocos aninhados. */}
        {!data.blocks_layout?.items?.length && data.text && (
          <LegacyText text={data.text} />
        )}
        <ContainerEdit
          {...props}
          selectedBlock={selectedBlock}
          setSelectedBlock={(id: string | null) =>
            dispatch(setUIState({ featurePanelSelected: id }))
          }
          direction="vertical"
        />
      </FeaturePanelFrame>
    </div>
  );
};

export default FeaturePanelEdit;
